import React from "react";
import ReactDOM from "react-dom";
import { ThemeProviderWrapper } from "@selfpub/selfpub-ui";
import FaqSearch from "scripts/services/search/faq";
document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render( /*#__PURE__*/React.createElement(ThemeProviderWrapper, null, /*#__PURE__*/React.createElement(FaqSearch, null)), document.getElementById("root"));
});